import * as React from 'react';
import { Col, Layout, Menu, Row, Typography } from 'antd';
import { NavLink } from 'react-router-dom';
import { default as SiteMenu, linkTypes } from './SiteMenu';
import { GlobalContext } from '../../Contexts/GlobalContext';
import { Contract, User } from 'tree-wallet-client';
import MenuContractSelector from './MenuContractSelector';


const { Sider } = Layout;
const { Title } = Typography;

import logo from '../../../assets/icons/usf-logo-blue.png';

export default class DesktopMenu extends SiteMenu {
  static contextType = GlobalContext;
  declare context: React.ContextType<typeof GlobalContext>;

  render() {
    const { opened } = this.state;
    const links = this.getLinks();

    return (
      <GlobalContext.Consumer>
        {({ user, contracts, contract }) => {
          return <Sider theme='light' className='menu desktop' collapsible collapsed={opened} onCollapse={this.toggle}>
            <div style={{ textAlign: 'center' }}>
              <img src={logo} width={'90%'} height={'90%'} />
            </div>
            {contracts &&
              <Row style={{ textAlign: 'center', margin: '20px 0', visibility: 'hidden' }}>
                <Col span={24}><Title level={5} style={{ color: 'white' }}>Current contract</Title></Col>
                <Col span={24}><MenuContractSelector /></Col>
              </Row>
            }
            <Menu theme="light" defaultSelectedKeys={['1']} mode="inline">
              {links.map((link: any) => this.renderLink(user, contract, link))}
            </Menu>
            <div id={'desktop-version-number'}>
              <div>Build 26101300</div>
            </div>
          </Sider>
        }}
      </GlobalContext.Consumer>
    );
  }

  renderLink(user: User | undefined, contract: Contract | undefined, link: any) {
    const { navigate } = this.context;

    if (!this.shouldDisplayLink(user, contract, link)) {
      return null;
    }

    const linkProps = { style: { color: '#fff' }, className: 'menu-link' };

    const template = (link: any) => {
      switch (link.type) {
        case linkTypes.logout:
          return <NavLink{...linkProps} to={'/'} onClick={() => link.onClick(navigate)}>{link.text}</NavLink>;
        case linkTypes.btn:
          return <span {...linkProps} onClick={() => link.onClick()}>{link.text}</span>;
        default:
          return <NavLink {...linkProps} to={link.link}>{link.text}</NavLink>;
      }
    }
    return (
      <Menu.Item key={"2" + link.link} style={{ backgroundColor: link.type === linkTypes.btn ? "inherit" : "" }} icon={link.icon}>
        {link && template(link)}
      </Menu.Item>
    );
  }
}